{
  "familyId": "MET-MEETK-DIAMETER",
  "questions": [
    {
      "id": "MET-MEETK-DIAMETER-001",
      "familyId": "MET-MEETK-DIAMETER",
      "module": "Metriek",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_diameter_straal",
      "questionType": "multiple_choice",
      "question": "Een cirkel heeft een diameter van 14 cm. Hoe lang is de straal?",
      "options": ["7 cm", "28 cm", "14 cm", "3,5 cm"],
      "correctAnswer": 0,
      "stimulusAids": [{"type":"circle","data":{"diameter":14,"highlightDiameter":true,"label":"Cirkel met diameter 14 cm"}}],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Diameter en straal",
            "content": "De diameter is de afstand dwars door het midden van de cirkel. De straal is de helft van de diameter: straal = diameter ÷ 2.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "diameter_naar_straal",
      "variantIndex": 1,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "De straal is de helft van de diameter: straal = diameter ÷ 2. Reken: 14 ÷ 2 = 7 cm. Waarom de helft? Omdat de diameter van rand tot rand gaat door het middelpunt, en de straal maar van het middelpunt tot de rand. Onthoud: diameter = 2 × straal, straal = diameter ÷ 2.",
        "solutionSteps": [
          "Formule: straal = diameter ÷ 2",
          "Invullen: 14 ÷ 2 = 7 cm",
          "Check: 2 × 7 = 14 cm (diameter) ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! De straal is de helft van de diameter: 14 ÷ 2 = 7 cm.",
          "1": "Je dacht waarschijnlijk dat je de diameter moest verdubbelen. Maar de straal is de helft van de diameter, niet het dubbele. Onthoud: straal = diameter ÷ 2.",
          "2": "Je dacht waarschijnlijk dat straal en diameter hetzelfde zijn. Maar de straal gaat van het middelpunt naar de rand, de diameter gaat helemaal door. Onthoud: diameter = 2 × straal.",
          "3": "Je dacht waarschijnlijk dat je door 4 moest delen. Maar je deelt door 2, niet door 4. Onthoud: straal = diameter ÷ 2."
        }
      }
    },
    {
      "id": "MET-MEETK-DIAMETER-002",
      "familyId": "MET-MEETK-DIAMETER",
      "module": "Metriek",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_diameter_straal",
      "questionType": "multiple_choice",
      "question": "Een fietswiel heeft een straal van 35 cm. Hoe groot is de diameter?",
      "options": ["17,5 cm", "35 cm", "70 cm", "105 cm"],
      "correctAnswer": 2,
      "stimulusAids": [{"type":"circle","data":{"radius":35,"highlightRadius":true,"label":"Cirkel met straal 35 cm"}}],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Van straal naar diameter",
            "content": "De diameter is twee keer de straal: diameter = straal × 2.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "straal_naar_diameter",
      "variantIndex": 2,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "De diameter is twee keer de straal: diameter = straal × 2. Reken: 35 × 2 = 70 cm. Waarom het dubbele? Omdat de diameter van rand tot rand gaat — dat is twee keer de straal (middelpunt → rand). Onthoud: diameter = 2 × straal.",
        "solutionSteps": [
          "Formule: diameter = straal × 2",
          "Invullen: 35 × 2 = 70 cm",
          "Check: 70 ÷ 2 = 35 cm (straal) ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je de straal moest halveren. Maar de diameter is het dubbele van de straal, niet de helft. Onthoud: diameter = straal × 2.",
          "1": "Je dacht waarschijnlijk dat straal en diameter hetzelfde zijn. Maar de diameter gaat helemaal door de cirkel, de straal maar tot het midden. Onthoud: diameter = 2 × straal.",
          "2": "Goed! De diameter is twee keer de straal: 35 × 2 = 70 cm.",
          "3": "Je dacht waarschijnlijk dat je met 3 moest vermenigvuldigen. Maar de diameter is 2 keer de straal, niet 3 keer. Onthoud: diameter = straal × 2."
        }
      }
    },
    {
      "id": "MET-MEETK-DIAMETER-003",
      "familyId": "MET-MEETK-DIAMETER",
      "module": "Metriek",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_diameter_straal",
      "questionType": "multiple_choice",
      "question": "Welke uitspraak over een cirkel is WAAR?",
      "options": ["De straal is langer dan de diameter", "De diameter gaat altijd door het middelpunt", "Een cirkel heeft maar één straal", "De diameter is de helft van de straal"],
      "correctAnswer": 1,
      "stimulusAids": [{"type":"circle","data":{"radius":5,"highlightRadius":true,"highlightDiameter":true,"label":"Cirkel met straal en diameter"}}],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Begrippen bij een cirkel",
            "content": "Middelpunt = het midden. Straal = van middelpunt naar rand. Diameter = van rand tot rand, door het middelpunt. Diameter = 2 × straal.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cirkel_begrippen",
      "variantIndex": 3,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De diameter is een lijn die van de ene kant van de cirkel naar de andere gaat, altijd door het middelpunt. De straal is de helft van de diameter. Er zijn oneindig veel stralen (vanuit het middelpunt naar elk punt op de rand), maar ze zijn allemaal even lang.",
        "solutionSteps": [
          "Diameter = lijn door het middelpunt, van rand tot rand",
          "Straal = van middelpunt naar rand",
          "Diameter = 2 × straal (dus diameter is langer)"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat de straal langer is. Maar de straal is de helft van de diameter. Onthoud: diameter = 2 × straal, dus de diameter is altijd langer.",
          "1": "Goed! De diameter gaat altijd door het middelpunt van de cirkel.",
          "2": "Je dacht waarschijnlijk dat er maar één straal is. Maar je kunt vanuit het middelpunt naar elk punt op de rand een straal trekken — er zijn oneindig veel stralen. Ze zijn allemaal even lang.",
          "3": "Je hebt straal en diameter omgedraaid. De diameter is het dubbele van de straal, niet de helft. Onthoud: diameter = 2 × straal."
        }
      }
    },
    {
      "id": "MET-MEETK-DIAMETER-004",
      "familyId": "MET-MEETK-DIAMETER",
      "module": "Metriek",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_diameter_straal",
      "questionType": "multiple_choice",
      "question": "Een tuinier maakt een rond bloemperk met een diameter van 3 meter. Hoe ver is het van het midden tot de rand?",
      "options": ["3 meter", "6 meter", "0,75 meter", "1,5 meter"],
      "correctAnswer": 3,
      "stimulusAids": [{"type":"circle","data":{"diameter":3,"highlightDiameter":true,"label":"Rond bloemperk met diameter 3 meter"}}],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Van midden tot rand = straal",
            "content": "De afstand van het midden tot de rand is de straal. Straal = diameter ÷ 2.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "diameter_straal_context",
      "variantIndex": 4,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Van het midden tot de rand is de straal. De straal is de helft van de diameter: 3 ÷ 2 = 1,5 meter. De tuinier hoeft dus maar 1,5 meter vanaf het midden te meten om de rand van het bloemperk te bereiken. Onthoud: straal = diameter ÷ 2.",
        "solutionSteps": [
          "Van midden tot rand = straal",
          "Straal = diameter ÷ 2",
          "3 ÷ 2 = 1,5 meter"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat de afstand van het midden tot de rand gelijk is aan de diameter. Maar dat is de straal, en die is de helft. Onthoud: straal = diameter ÷ 2.",
          "1": "Je dacht waarschijnlijk dat je de diameter moest verdubbelen. Maar je moet hem halveren om de straal te krijgen. Onthoud: straal = diameter ÷ 2.",
          "2": "Je dacht waarschijnlijk dat je door 4 moest delen. Maar de straal is de helft van de diameter, dus je deelt door 2. Onthoud: straal = diameter ÷ 2.",
          "3": "Goed! De straal is de helft van de diameter: 3 ÷ 2 = 1,5 meter."
        }
      }
    },
    {
      "id": "MET-MEETK-DIAMETER-005",
      "familyId": "MET-MEETK-DIAMETER",
      "module": "Metriek",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_diameter_straal",
      "questionType": "fill_in",
      "question": "Een cirkel heeft een straal van 9 cm. Hoe groot is de diameter? Typ je antwoord in cm (bijv. 18).",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["18", "18 cm"],
        "caseSensitive": false,
        "placeholder": "? cm"
      },
      "stimulusAids": [{"type":"circle","data":{"radius":9,"highlightRadius":true,"label":"Cirkel met straal 9 cm"}}],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Diameter berekenen",
            "content": "Diameter = straal × 2. Dus: 9 × 2 = 18 cm.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "straal_naar_diameter_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Diameter = straal × 2 = 9 × 2 = 18 cm. De diameter loopt van de ene kant van de cirkel naar de andere, dwars door het middelpunt. Controleer: 18 ÷ 2 = 9 cm ✓.",
        "solutionSteps": [
          "Formule: diameter = straal × 2",
          "Invullen: 9 × 2 = 18 cm",
          "Check: 18 ÷ 2 = 9 cm (straal) ✓"
        ]
      }
    }
  ]
}